import { Variable } from "@/oxygen/variables/lib/types";

export function mergeVariables(
  existingVariables: Variable[],
  variablesToMerge: Variable[],
  propToMerge: "id" | "cssVariableName" = "cssVariableName",
  reuseIds = true
) {
  const newVariablesByProp = variablesToMerge.map(
    variable => variable[propToMerge]
  );

  const variablesToKeep = existingVariables.filter(
    variable => !newVariablesByProp.includes(variable[propToMerge])
  );

  const newVariables = variablesToMerge.map(variable => {
    const existingVariable = existingVariables.find(
      existingVariable =>
        existingVariable[propToMerge] === variable[propToMerge]
    );

    // Keep the ID of the existing variable if it exists.
    // If a variable is already in use, we want to keep its ID to avoid breaking references.
    if (existingVariable && reuseIds) {
      variable.id = existingVariable.id;
    }

    return variable;
  });

  return {
    variablesToKeep,
    variables: [...variablesToKeep, ...newVariables]
  };
}
